import { connect } from "react-redux";
import NdisClaim from "./NdisClaim";
import {
  getCaseNotesListForClaimsRequest,
  getClaimedCaseNotesListRequest,
  getClientsRequest,
  getNdisClaimModeRequest,
  updateNdisClaimModeRequest,
  changeNDISClaimCaseNoteStatusRequest,
} from "../../../store/actions/cos.actions";
import {
  getClaimedCaseNotesListLoadingSelector,
  getClaimedCaseNotesListSelector,
  getSelectedClientsListSelector,
  ndisClaimModeSelector,
  changeNDISCaseNotesStatusLoadingSelector,
} from "../../../store/selector/cos.selector";

const mapDispatchToProps = {
  getCaseNotesRequest: getCaseNotesListForClaimsRequest,
  getClientsRequest,
  getClaimCaseNotesRequest: getClaimedCaseNotesListRequest,
  getNdisClaimMode: getNdisClaimModeRequest,
  updateNdisClaimMode: updateNdisClaimModeRequest,
  changeClaimStatus: changeNDISClaimCaseNoteStatusRequest,
};

const mapStateToProps = (state) => {
  const claimedCaseNotesList = getClaimedCaseNotesListSelector(state);
  const selectedClientList = getSelectedClientsListSelector(state);
  const claimedCaseNotesListLoading =
    getClaimedCaseNotesListLoadingSelector(state);
  const ndisClaimMode = ndisClaimModeSelector(state);
  const changeClaimStatusLoading =
    changeNDISCaseNotesStatusLoadingSelector(state);
  return {
    claimedCaseNotesList,
    claimedCaseNotesListLoading,
    selectedClientList,
    ndisClaimMode,
    changeClaimStatusLoading,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NdisClaim);
